export const TriggerKeys = {
  KEY_RETURN: "Enter",
  KEY_ENTER: "Enter",
  KEY_TAB: "Tab",
  KEY_SPACE: " ",
};
